import React from "react";
import Schedule from "./components/Schedule";
import Footer from "../components/Footer";

const Programacion: React.FC = () => {
  return (
    <article className="min-h-screen pt-28 md:pt-32">
      <Schedule />
      <Footer />
    </article>
  );
};

export default Programacion;
